const setting = require('@/settings.js')

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

const time = {
  formatTime: date => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
  },
  now: () => {
    return time.formatTime(new Date())
  },
  day: (ts) => {
    const date = ts? (new Date(ts)): (new Date())
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return [year, month, day].map(formatNumber).join('-')
  },
  format: (arr, sp) => {
    return arr.map(formatNumber).join(sp)
  }
}

const sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

const hex = byteArray => {
  return Array.from(byteArray, function(byte) {
    return ('0' + (byte & 0xFF).toString(16)).slice(-2);
  }).join('').toUpperCase()
}

const help = {
  title: (str)  => {
    const title = setting.title || ''
    if (str) {
      return `${str} - ${title}`
    }
    return `${title}`
  },
  round: (value, n) => {
    return Math.round(value * Math.pow(10, n)) / Math.pow(10, n)
  }
}

export default {
  time: time,
  sleep: sleep,
  help: help,
  hex: hex
}
